import React from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip
} from "@mui/material";
import { Search, RefreshCw } from "lucide-react";

const EventHeader = ({
  timelineStatus,
  searchQuery,
  setSearchQuery,
  fixedEventType = null,
  onRefresh = null,
  isRefreshing = false
}) => {
  const getHeaderTitle = () => {
    const eventPrefix = fixedEventType ? `${fixedEventType} ` : "";
    if (timelineStatus === "ongoing" || timelineStatus === "past" || timelineStatus === "completed") {
      return `${eventPrefix}Social Banner`;
    }
    return `${eventPrefix}Banner Upload`;
  };

  const getHeaderSubtitle = () => {
    const eventLabel = fixedEventType || "FDP and Tech Camp";
    if (timelineStatus === "ongoing" || timelineStatus === "past" || timelineStatus === "completed") {
      return `View and upload social media banners and download approved geo-tagged photos for ${eventLabel} events.`;
    }
    return `View and manage banner uploads for ${eventLabel} events.`;
  };

  return (
    <Box sx={{ mb: 2.5 }}>
      {/* Page Title & Subtitle */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#0f172a",
              fontSize: { xs: "1.2rem", sm: "1.35rem" },
              letterSpacing: "-0.01em",
              mb: 0.25
            }}
          >
            {getHeaderTitle()}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#64748b", fontSize: "0.8125rem" }}
          >
            {getHeaderSubtitle()}
          </Typography>
        </Box>

        {/* Search Bar & Refresh */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: { xs: "100%", sm: "auto" } }}>
          <TextField
            size="small"
            placeholder="Search by institute or domain name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search size={15} color="#94a3b8" />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "8px",
                backgroundColor: "#ffffff",
                fontSize: "0.8125rem",
                height: "36px",
                width: { xs: "100%", sm: "280px", md: "320px" },
                "& fieldset": { borderColor: "#e2e8f0" },
                "&:hover fieldset": { borderColor: "#cbd5e1" },
                "&.Mui-focused fieldset": { borderColor: "#1877f2" }
              }
            }}
          />

          {onRefresh && (
            <Tooltip title="Refresh requests list" arrow>
              <IconButton
                onClick={onRefresh}
                size="small"
                sx={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  p: 0.9,
                  color: "#64748b",
                  "&:hover": {
                    backgroundColor: "#f8fafc",
                    borderColor: "#cbd5e1",
                    color: "#1877f2"
                  }
                }}
              >
                <RefreshCw
                  size={16}
                  style={{
                    animation: isRefreshing ? "spin 1s linear infinite" : "none"
                  }}
                />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EventHeader;

